<template>
  <div class="overlay" v-if="visible">
    <div class="container">
      <div class="pt-title" v-text="title"></div>
      <div class="pt-header">
          
        <span
          v-for="(column, index) in columnDefs"
          :key="index"
          v-text="column.label"
        ></span>
      </div>
      <div class="pt-body">
        <div class="rows" :key="divKey" v-for="(row, divKey) in dataSet.map(preRender)" :class="{highLightRed: row.highLightRed}">
          <span :key="spanKey" v-for="(column, spanKey) in columnDefs" v-text="row[column.name]"></span>
        </div>
      </div>
      <div class="footer-records">
        <span v-if="showCountRecords == true" v-text="labelCountRecords"></span>
        <span v-if="showCountRecords == true">{{getNumberRecords}}</span>
      </div>
      <div class="pt-footer">
        <button class="button gray-button" @click="chooseAction('CANCEL')">
          <i class="fas fa fa-arrow-left"></i>
          <span>{{$t('back')}}</span>
        </button>
        
        <div class="right-container">
          <button class="button gray-button" @click="exportToExcel">
            <i class="fas fa-file-excel"></i>
            <span>{{$t('export')}}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Util from "@/application/libs/util";
import ExcelBuilder from "@/application/libs/excelBuilder";
import { t } from 'i18next'
export default {
    name: "GridModalSimple",
    props: [
        'grid',
        'visible',
        'dataSet'
    ],
    created(){
        const {
          columnDefs = {}, 
          columnDefsToExport = columnDefs, 
          title = '',
          showCountRecords = true,
          labelCountRecords = t('number_of_records'),
          preRender = ( item ) => item,
          getCustomExcelHeader = Util.getExcelHeaderFromFilter
        } = this.grid;
        this.columnDefs = columnDefs;
        this.columnDefsToExport = columnDefsToExport;
        this.title = title;
        this.preRender = preRender;
        this.getCustomExcelHeader = getCustomExcelHeader;
        this.showCountRecords = showCountRecords;
        this.labelCountRecords = labelCountRecords;
        this.countRecords = 0;
    },
    computed: {
        getNumberRecords(){
            return this.dataSet.length;
        }
    },
    methods: {
        exportToExcel: function() {
            if(!this.columnDefsToExport) {
                this.columnDefsToExport = this.columnDefs.map( column => ({
                    header: column.label,
                    key: column.name
                }));
            }
            
            ExcelBuilder.fromJson(
                this.dataSet.map(this.preRender),
                this.columnDefsToExport,
                this.title,
                this.getCustomExcelHeader()
            );
            this.chooseAction('EXPORT');
        },
        chooseAction: function(action) {
            this.$emit("chooseAction", action);
        }
    }
}
</script>

<style scoped lang="less">
@import (reference) url("../../assets/variables.less");

.container {
  font-size: 13px;
  .sombra;
  padding: 0 15px;
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  border-radius: 5px;
  background: white;
  width: 70%;
}
.overlay {
    position: fixed;
    z-index: 10;
    .full;
    background: rgba(0, 0, 0, 0.5);
}
.gray-button {
  margin: 15px 0;
  padding: 5px;
  font-size: 1rem;
  box-shadow: none;
  background-color: #dedede;
  color: #383838;
  &:hover {
    background-color: gray;
    color: white;
  }
}
.pt-header {
  height: 34px;
  background: @azul;
  color: #fff;
  display: grid;
  grid-template-columns: 20% 30% 50%;
  span:first-of-type {
    padding-left: 5px;
    margin: auto 0;
  }
  span:not(:first-of-type) {
    text-align: center;
    padding-left: 5px;
    display: table;
    margin: auto;
  }
}
.pt-body {
  padding-bottom: 5px;
  border-bottom: solid 1px rgba(0, 0, 0, 0.5);
  max-height: 50vh;
  overflow: auto;
  .rows {
    &:nth-of-type(2n) {
      background: rgba(196, 196, 196, 0.2);
    }
    display: grid;
    grid-template-columns: 20% 30% 50%;
    span {
      margin: auto;
      padding: 5px;
      max-width: 100%;
      text-align: center;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      display: block;
    }
    span:first-of-type {
      text-align: left;
      margin: auto 0;
      padding-left: 5px;
      font-size: 13px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    span:not(:first-of-type) {
      text-align: center;
    }
  }
  .highLightRed {
    color: red;
  }
}
.pt-title {
  position: relative;
  display: block;
  margin: auto;
  text-align: center;
  padding: 15px 0;
  font-size: 16px;
}
.right-container {
  float: right;
  .gray-button {
    margin: 15px 7.5px;

    &:last-of-type {
      margin-right: 0;
    }
  }
}

.footer-records{
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  padding: 5px 0px; 
  font-size: 1.3em;
  span:nth-child(1){
    font-weight: bold;
    padding-right: 5px;
  }
}
</style>
